module.exports = "<div id=tplCerHisfer> <div class=u-row> <div class=u-col-12> <u-grid params=config:config></u-grid> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/qualiftTplRefer/index.html
// module id = 337
// module chunks = 144